"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = signedIn;

var _noty = require("noty");

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

function signedIn() {
  try {
    _SiteLayout.default.current.navigate(document.querySelector('base').href + 'catalog/PRODUCTS/Frequently-Ordered');

    require('modals/facilities-modal').initialFacilitiesModal.show();
  } catch (e) {}

  (0, _noty.showNotificationText)('You have been signed in.');
}